import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from '@utils/api';
import { AppDispatch } from 'src/redux/store';
import { Sync } from '@customTypes/shared/Sync';

export const fetchSyncsRequest = createAction('fetchSyncsRequest');
export const fetchSyncsSuccess = createAction<Sync[]>('fetchSyncsSuccess');
export const fetchSyncsFailure = createAction('fetchSyncsFailure');

export const fetchSyncs = () => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(fetchSyncsRequest());
    try {
        const { data }: Response = await api.get(`syncs`);
        dispatch(
            fetchSyncsSuccess(
                data.map(singleSync => {
                    return { ...singleSync, id: singleSync.sync.id };
                }),
            ),
        );
    } catch (e) {
        handleApiErrors(dispatch, fetchSyncsFailure, e);
    }
};

interface Response {
    data: Sync[];
}
